var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm.storeData.length
      ? _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("p", [_vm._v("Выберите препарат для реализации")]),
              _vm._v(" "),
              _c("DrugSearchNew", {
                ref: "searchDrug",
                attrs: {
                  drugsForSearch: _vm.storeData.map((r) => r.drug),
                  onSelect: (d) => _vm.selectDrug(d),
                },
              }),
              _vm._v(" "),
              _vm.drugsForClose.length
                ? _c("div", [
                    _c(
                      "table",
                      { staticClass: "table mt-0 table-sm table-hover" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.drugsForClose, function (r, i) {
                            return _c("tr", { key: r.drug.id }, [
                              _c("td", [_vm._v(_vm._s(i + 1))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.drug.title))]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.qty,
                                      expression: "r.qty",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder: "Кол.",
                                  },
                                  domProps: { value: r.qty },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(r, "qty", $event.target.value)
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.price,
                                      expression: "r.price",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder: "Цена",
                                  },
                                  domProps: { value: r.price },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(r, "price", $event.target.value)
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeDrug(r.drug.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-remove",
                                    }),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "table",
          { staticClass: "table mt-0 table-sm table-striped table-hover" },
          [
            _c(
              "tbody",
              _vm._l(_vm.storeData, function (s, i) {
                return _c("tr", [
                  _c("td", [_vm._v(_vm._s(i + 1))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(s.drug.title))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(s.qty))]),
                ])
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading.store,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table mt-0 table-sm table-striped table-hover" },
            [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.invoices, function (inv, i) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-xs btn-info",
                          on: {
                            click: function ($event) {
                              return _vm.showInvoice(inv.id)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                      ),
                      _vm._v(
                        "\n            " + _vm._s(inv.id) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.printDate(inv.delivery_date, "DD.MM.YYYY"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v("препаратов: "),
                      _c("strong", [_vm._v(_vm._s(inv.details.length))]),
                      _vm._v(" на сумму\n            "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            inv.details.reduce(
                              (acc, d) => acc + +d.qty * +d.cost_price,
                              0
                            )
                          )
                        ),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-success" }, [
      _c("h5", [_vm._v("Реализация препаратов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол.")]),
        _vm._v(" "),
        _c("th", [_vm._v("цена")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h5", [_vm._v("На реализации (склад)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h5", [_vm._v("Накладные")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "50px" } }),
        _vm._v(" "),
        _c("th", { attrs: { width: "150px" } }, [_vm._v("Накладная")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "150px" } }, [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }